// extracted by mini-css-extract-plugin
export default {"fieldName":"changePassword_fieldName__t0PsR","backbutton":"changePassword_backbutton__4ugpv"};